/**
 * User-visible copy for multi-rack list + per-unit editor (#995 / #1052, #1011 subsection parity).
 */

export const RACK_CONFIGURATIONS_LIST_TITLE = 'Rack units';

export const RACK_CONFIGURATIONS_LIST_SUBTITLE =
  'Each row is one rack configuration. Select a row to edit, or add a new unit below.';

export const RACK_EMPTY_STATE_TITLE = 'No Racks added yet';

export const RACK_EDIT_RACKS_CARD_SUBTITLE =
  'Platform, dimensions, quantity, and physical attributes for this rack unit.';

export const RACK_EDIT_POWER_CARD_SUBTITLE =
  'PDU specs, outlets, power type, and capacity for this rack unit.';

export const RACK_EDIT_ALL_RACKS_LABEL = 'All Racks';

export const RACK_EDIT_HEADER_TITLE_NEW = 'New Rack';

export const RACK_EDIT_RECORD_SUBTITLE_NEW = 'Add a new record';

export const RACK_EDIT_RECORD_SUBTITLE_EDIT = 'Editing record';

export const RACK_EDIT_STATUS_EXISTING_LABEL = 'Existing';

export const RACK_EDIT_STATUS_NEW_LABEL = 'New';

export const RACK_EDIT_RACK_TYPE_LABEL = 'Rack type';

/** Display labels for {@link FormTwoOptionChoice} — map to `rackStatus` existing | new. */
export const RACK_EDIT_RACK_TYPE_OPTIONS = [
  RACK_EDIT_STATUS_EXISTING_LABEL,
  RACK_EDIT_STATUS_NEW_LABEL,
] as const;

export const RACK_EDIT_DELETE_LABEL = 'Delete';

export const RACK_EDIT_SAVE_LABEL = 'Save Rack';

/** Create Request / draft flow — same label as persisted edit (#1154). */
export const RACK_EDIT_SAVE_DRAFT_LABEL = 'Save Rack';

export const RACK_EDIT_SAVE_DRAFT_HINT =
  'Adds this rack to the list. Save the request separately when ready.';

export const RACK_ROW_ACTION_EDIT_LABEL = 'Edit';

export const RACK_ROW_ACTION_VIEW_LABEL = 'View';

export const RACK_ROW_ACTION_DUPLICATE_LABEL = 'Duplicate';

/** List row overflow menu — short action labels (editor footer uses {@link RACK_EDIT_DELETE_LABEL}). */
export const RACK_ROW_ACTION_DELETE_LABEL = 'Delete';

export const RACK_DELETE_CONFIRM_TITLE = 'Delete Rack Configuration';

export const RACK_DELETE_CONFIRM_MESSAGE =
  'Are you sure you want to delete this rack configuration? This cannot be undone.';

export const RACK_DISCARD_UNSAVED_TITLE = 'Unsaved Changes';

export const RACK_DISCARD_UNSAVED_MESSAGE =
  'You have unsaved changes. Discard them?';

export const RACK_DISCARD_UNSAVED_KEEP_EDITING_LABEL = 'Stay';

export const RACK_DISCARD_UNSAVED_DISCARD_LABEL = 'Discard';

/** @deprecated Use RACK_EDIT_RECORD_SUBTITLE_* on summary card. */
export const RACK_EDIT_HEADER_SUBTITLE_NEW =
  'Enter rack and PDU details for this unit, then save to return to the list.';

/** @deprecated Use RACK_EDIT_RECORD_SUBTITLE_EDIT on summary card. */
export const RACK_EDIT_HEADER_SUBTITLE_EDIT =
  'Update rack and PDU details for this unit.';
